export default __webpack_public_path__ + "static/media/gray-ray.8db13169.svg";